import { createBrowserHistory } from "history";

export default createBrowserHistory();
// this file was created to have access to the History object outside Router